// Bilingual route map. Each key maps to a FR / EN / IT / RU URL.
export const ROUTES = {
  home:         { fr: "/",              en: "/",              it: "/",            ru: "/" },
  treatments:   { fr: "/soins",         en: "/treatments",    it: "/trattamenti", ru: "/procedury" },
  yacht:        { fr: "/yachts",        en: "/yacht-services", it: "/yacht",      ru: "/yakhty" },
  villa:        { fr: "/villa-conciergerie", en: "/villa-concierge", it: "/villa-concierge", ru: "/villa-concierge" },
  xpTherapy:    { fr: "/notre-therapie", en: "/our-therapy",   it: "/nostra-terapia", ru: "/nasha-terapiya" },
  exomobil:     { fr: "/exomobil",      en: "/exomobil",      it: "/exomobil",    ru: "/exomobil" },
  booking:      { fr: "/reservation",   en: "/booking",       it: "/prenotazione", ru: "/zapis" },
  partners:     { fr: "/partenaires",   en: "/partners",      it: "/partner",     ru: "/partnery" },
  investors:    { fr: "/investisseurs", en: "/investors",     it: "/investitori", ru: "/investory" },
  investorMode: { fr: "/investor-mode", en: "/investor-mode", it: "/investor-mode", ru: "/investor-mode" },
  admin:        { fr: "/admin",         en: "/admin",         it: "/admin",       ru: "/admin" },
};

export const SUPPORTED_LANGS = ["fr", "en", "it", "ru"];

export function pathFor(key, lang) {
  const r = ROUTES[key];
  if (!r) return "/";
  return r[lang] || r.en || r.fr;
}

export function keyForPath(pathname) {
  for (const [k, v] of Object.entries(ROUTES)) {
    if (Object.values(v).includes(pathname)) return k;
  }
  return null;
}
